<script lang="ts">
    import { onChange } from "../../components/formComponents/helper"
    import Input from "../../components/formComponents/Input.svelte"

    export let field: TaskStepField<"number">,
        fullPath: string,
        value: Number = undefined
</script>

<div class="numberWidget">
    <Input
        placeholder="{field.label}"
        id="{fullPath}-{field.name}"
        type="number"
        onChange="{onChange}"
        bind:value="{value}"
    />
</div>

<style lang="less">
    .numberWidget:global {
        width: 100%;
    }
</style>
